import { render, staticRenderFns } from "./HistogramMap.vue?vue&type=template&id=863f5d12&scoped=true&"
import script from "./HistogramMap.vue?vue&type=script&lang=js&"
export * from "./HistogramMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863f5d12",
  null
  
)

export default component.exports